module.exports = __webpack_public_path__ + "static/media/result.e05d60e8.png";